const getFieldDomByCode = (code: string) => document.querySelector<HTMLDivElement>(`[data-xformcode=${code}]`)

export default getFieldDomByCode
